import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router';

import { Icon } from '@/components/ui/Icon';
import type { NavSection } from '@/layouts/navigation';
import clsx from '@/utils/clsx';

import styles from './AppLayout.module.css';

interface AppNavProps {
  sections: NavSection[];
  activeTarget: string | null;
}

/** Desktop (≥ lg) navbar links; sections with `display: 'dropdown'` open a menu. */
export function AppNav({ sections, activeTarget }: AppNavProps) {
  return (
    <nav aria-label="Main" className={clsx('d-none d-lg-flex', styles.topNav)}>
      {sections.map((section) => {
        if (section.display === 'mobile-only') return null;
        if (section.display === 'dropdown') {
          const isActive = section.items.some((item) => item.to === activeTarget);
          return (
            <Dropdown key={section.id}>
              <Dropdown.Toggle
                variant="link"
                id={`nav-${section.id}`}
                className={clsx(styles.topNavLink, isActive && styles.topNavActive)}
              >
                {section.icon && <Icon name={section.icon} />}
                {section.title}
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.topNavMenu}>
                {section.items.map((item) => (
                  <Dropdown.Item
                    key={item.to}
                    as={Link}
                    to={item.to}
                    active={item.to === activeTarget}
                    aria-current={item.to === activeTarget ? 'page' : undefined}
                  >
                    <Icon name={item.icon} className="me-2" />
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          );
        }
        return section.items.map((item) => {
          const isActive = item.to === activeTarget;
          return (
            <Link
              key={item.to}
              to={item.to}
              className={clsx(styles.topNavLink, isActive && styles.topNavActive)}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon name={item.icon} />
              {item.label}
            </Link>
          );
        });
      })}
    </nav>
  );
}
